export default __webpack_public_path__ + "static/logo-38473af1dd1c2eec70afd173f7638dbd.png";